import * as React from "react"
import { type LucideIcon } from "lucide-react"
import { useLocation, useNavigate } from "react-router-dom"
import { handleNavigationWithPaywall } from "@/utils/paywall-navigation-utils"

import { isMenuItemActive } from "../../utils/sidebar-utils"

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "../../components/ui/sidebar"

function NavSecondary({
  items,
  ...props
}: {
  items: {
    title: string
    url: string
    icon: LucideIcon
    component?: boolean
    renderComponent?: (item: any) => React.ReactNode
  }[]
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname.substring(1); // Get current path without leading slash
  return (
    <SidebarGroup {...props}>
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => (
            <SidebarMenuItem key={item.title}>
              {item.component && item.renderComponent ? (
                // Render custom component if component is true and renderComponent is provided
                item.renderComponent(item)
              ) : (
                // Default behavior for regular links
                <SidebarMenuButton asChild size="sm" isActive={isMenuItemActive(item.url, currentPath)}>
                  <a href={item.url} target={item.url.startsWith('#') ? undefined : "_blank"} onClick={(e) => {
                    const paywallDialog = handleNavigationWithPaywall(item.url, navigate, e);
                    if (paywallDialog) { return paywallDialog; }
                  }}
                  data-sentry-unmask>
                    <item.icon data-sentry-unmask />
                    <span data-sentry-unmask>{item.title}</span>
                  </a>
                </SidebarMenuButton>
              )}
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}

export { NavSecondary }
